<template>
	<div class="wrap">
		<div class="main">
			<div class="neibox">
				<el-button @click="getApplyPageData" type="primary">申请开票</el-button>
				<div class="kekaibox">
					<div class="kailinea"></div>
					<div class="kaititle">
						可开票订单
					</div>
					<div class="kailine"></div>
				</div>
				<el-table  ref="multipleTable" :data="tableData"
					tooltip-effect="dark" style="width: 100%;border: 1px solid #eeeeee;border-bottom: none;"
					@selection-change="handleSelectionChange">
					<el-table-column type="selection" width="100">
					</el-table-column>
					<el-table-column prop="create_time" label="交易时间" width="200">
					</el-table-column>
					<el-table-column prop="is_add" label="交易类型" width="200">
						<template slot-scope="scope">
							<div class="taiboxact" v-if="scope.row.is_add == 0">扣款</div>
							<div class="taiboxact" v-else-if="scope.row.is_add == 1">入款</div>
							<div class="taiboxact" v-else>虚增</div>
						</template>
					</el-table-column>
					<el-table-column prop="bank" label="交易渠道" width="200">
					</el-table-column>
					<el-table-column prop="money" label="交易金额" width="200">
					</el-table-column>
					<el-table-column prop="money2" label="可用余额" width="200">
					</el-table-column>
					<el-table-column prop="forwhat" label="交易描述" min-width="400">
					</el-table-column>
				</el-table>
				<div class="fenye">
					<FenPage :total="ke_page.total" :page.sync="ke_page.page" :limit.sync="ke_page.limit" @pagination="getOrderLog" />
				</div>

				<div class="kekaibox">
					<div class="kailinea"></div>
					<div class="kaititle">
						开票记录
					</div>
					<div class="kailine"></div>
				</div>

				<el-table  ref="multipleTable" :data="yikaiData"
					tooltip-effect="dark" style="width: 100%;border: 1px solid #eeeeee;border-bottom: none;"
					@selection-change="handleSelectionChange">
					<el-table-column prop="create_time" label="申请时间">
					</el-table-column>
					<el-table-column prop="type" label="发票类型">
					</el-table-column>
					<el-table-column prop="flag" label="发票税号">
					</el-table-column>
					<el-table-column prop="title" label="发票抬头">
					</el-table-column>
					<el-table-column prop="money" label="发票余额">
					</el-table-column>
					<el-table-column prop="status" label="状态">
						<template slot-scope="scope">
							<div class="taiboxact" v-if="scope.row.status == 0">待受理</div>
							<div class="taiboxact" v-else-if="scope.row.status == 1">已受理</div>
							<div class="taiboxact" v-else>已完结</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="fenye">
					<FenPage :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getFaPiaoLog" />
				</div>
			</div>

			<el-dialog title="申请发票" top="10vh" :visible.sync="show" width="60%" :before-close="handleClose">
				<div class="xubox">
					<div class="xuli">
						<div class="xulefttxt">
							发票抬头
						</div>
						<el-input style="width: 50%;" v-model="info.title" placeholder="发票抬头"></el-input>
						<div class="xing">*</div>
					</div>
					<div class="xuli">
						<div class="xulefttxt">
							发票金额
						</div>
						<el-input style="width: 50%;"  disabled v-model="info.money" placeholder="发票金额"></el-input>
						<div class="xing">*</div>
					</div>
					<div class="xuli">
						<div class="xulefttxt">
							发票类型
						</div>
						<el-select @change="qieTab" style="width: 50%;" v-model="value" placeholder="请选择">
							<el-option  v-for="item in options" :key="item.value" :label="item.label"
								:value="item.label">
							</el-option>
						</el-select>
					</div>
					<!-- <div class="xuli">
						<div class="xulefttxt">
							电子发票
						</div>
						<el-switch @change="switchChange"
						  v-model="isTrue"
						  active-color="#13ce66"
						  inactive-color="#dddddd">
						</el-switch>
					</div> -->
					<div class="xuli" >
						<div class="xulefttxt">
							电子邮箱
						</div>
						<el-input style="width: 50%;" v-model="info.email" placeholder="电子邮箱"></el-input>
					</div>
					<div class="xuli" v-if="qiye">
						<div class="xulefttxt">
							纳税人识别号
						</div>
						<el-input style="width: 50%;" v-model="info.flag" placeholder="纳税人识别号"></el-input>
						<div class="xing">*</div>
					</div>
					<div class="xuli" v-if="qiye">
						<div class="xulefttxt">
							基本开户银行
						</div>
						<el-input style="width: 50%;" v-model="info.bank" placeholder="基本开户银行"></el-input>
					</div>
					<div class="xuli" v-if="qiye">
						<div class="xulefttxt">
							基本开户账号
						</div>
						<el-input style="width: 50%;" v-model="info.account" placeholder="基本开户账号"></el-input>
					</div>
					<div class="xuli" v-if="qiye">
						<div class="xulefttxt">
							企业注册地址
						</div>
						<el-input style="width: 50%;" v-model="info.address" placeholder="企业注册地址"></el-input>
					</div>
					<div class="xuli" v-if="qiye">
						<div class="xulefttxt">
							企业注册电话
						</div>
						<el-input style="width: 50%;" v-model="info.tel" placeholder="企业注册电话"></el-input>
					</div>
					<!-- <div class="xuli">
						<div class="xulefttxt">
							收件人姓名
						</div>
						<el-input style="width: 50%;" v-model="info.name" placeholder="收件人姓名,无需邮寄可不填写"></el-input>
					</div>
					<div class="xuli">
						<div class="xulefttxt">
							收件人电话
						</div>
						<el-input style="width: 50%;" v-model="info.phone" placeholder="收件人电话,无需邮寄可不填写"></el-input>
					</div>
					<div class="xuli">
						<div class="xulefttxt">
							收件人地址
						</div>
						<el-input style="width: 50%;" v-model="info.add" placeholder="收件人地址,无需邮寄可不填写"></el-input>
					</div> -->
					<span slot="footer" class="dialog-footer">
						<el-button type="primary" @click="getApply">确认</el-button>
						<el-button @click="show = false">返回</el-button>
					</span>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import FenPage from '../../components/FenPage.vue'
	export default {
		components:{
			FenPage
		},
		data() {
			return {
				show: false,
				tableData: [],
				// 可开票订单
				ke_page: {
					limit: 20,
					page: 1,
					total:20,
				},
				// 已开记录
				yikaiData: [],
				// 已开记录分页
				page_data: {
					limit: 20,
					page: 1,
					total:20,
				},
				// 分页
				currentPage: 1,
				options: [{
					value: '1',
					label: '企业普通发票'
				}, {
					value: '2',
					label: '企业专用发票'
				}, {
					value: '3',
					label: '个人普通发票'
				}],
				info: {
					title: '',
					money: '',
					type:'',
					is_d: 0,
					email:'',
					flag:'',
					bank:'',
					account:'',
					address:'',
					tel:'',
					name:'',
					phone:'',
					add:'',
					ids:[],
				},
				isTrue:false,
				value: '',
				qiye:true,
				puqi:true,
				ids:[]
			}
		},
		created() {
			this.getFaPiaoLog()
			this.getOrderLog()
		},
		methods: {
			
			// 已开记录
			async getFaPiaoLog() {
				this.yikaiData = []
				let param = {limit:this.page_data.limit,page:this.page_data.page}
				const res = await this.$api.getFaPiaoLog(param);
				this.yikaiData = res.data.data
				this.page_data.total = res.data.total
			},
			
			// 可开票订单
			async getOrderLog() {
				this.tableData = []
				let param = {limit:this.ke_page.limit,page:this.ke_page.page}
				const res = await this.$api.getOrderLog(param);
				this.tableData = res.data.data
				this.ke_page.total = res.data.total
			},
			// 开票
			handleSelectionChange(val) {
				this.multipleSelection = val;
				
				let idArray = this.multipleSelection.map(item => item.id);
				let newArray = idArray.join(',');
				this.ids = newArray.split(',');
				this.info.ids = this.ids
			},
			// 申请开票详情
			async getApplyPageData() {
				if(this.ids.length < 1){
					alert('请选择需开票的订单')
					return
				}
				const res = await this.$api.getApplyPageData({
					ids:this.ids
				});
				console.log(res)
				this.info.money = res.data
				this.show = true
			},
			async getApply() {
				const res = await this.$api.getApply(this.info);
				if(res.code == 1){
					alert(res.msg)
					this.show = false
					this.getOrderLog()
					this.getFaPiaoLog()
				}else{
					alert(res.msg)
				}
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			},
			handleClose() {
				this.show = false
			},
			qieTab(e){
				this.info.type = this.value
				if(e == '企业专用发票'){
					this.qiye = true
					this.puqi = true
				}else if(e == '企业普通发票'){
					this.qiye = true
					this.puqi = false
				}else{
					this.qiye = false
					this.puqi = false
				}
			},
			switchChange(e){
				if(e == true){
					this.info.is_d = 1
				}else{
					this.info.is_d = 0
				}
			}
		},

	}
</script>

<style>
	.neibox {
		padding: 20px;
		background-color: #ffffff;
		border-radius: 5px;
	}

	.kekaibox {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 20px 0;
		border-top: 1px solid #eeeeee;
		margin-top: 20px;
	}

	.kailine {
		flex-grow: 1;
		height: 1px;
		background-color: #eeeeee;
	}

	.kailinea {
		width: 25px;
		height: 1px;
		background-color: #eeeeee;
	}

	.kaititle {
		font-size: 20px;
		color: #666666;
		line-height: 20px;
		padding: 0 10px;
		flex-shrink: 0;
	}

	.fenye {
		display: flex;
		align-items: center;
		justify-content: center;
		padding-top: 20px;
		padding-bottom: 30px;
	}

	.xubox {
		background-color: #ffffff;
		padding: 15px;
		margin-bottom: 15px;
	}

	.xuli {
		display: flex;
		align-items: center;
		padding-bottom: 15px;
	}

	.el-dialog__header {
		background-color: #f8f8f8 !important;
	}

	.el-dialog__body {
		background-color: #f2f2f2 !important;
	}

	.el-dialog__footer {
		background-color: #f2f2f2 !important;
	}

	.xulefttxt {
		width: 135px;
		text-align: right;
		font-size: 14px;
		color: #333333;
		padding-right: 15px;
	}

	.xing {
		font-size: 14px;
		color: #ff0000;
		padding-left: 10px;
	}
	.dialog-footer{
		padding-left: 150px;
	}
	.el-dialog__footer {
		text-align: left;
		
	}
	.taiboxact {
		width: 50px;
		height: 20px;
		background-color: #1E9FFF;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #ffffff;
		border-radius: 5px;
	}
	.el-input.is-disabled .el-input__inner {
	  color: #333333  !important;
	}
</style>